import React, { useEffect } from "react";
import CourierListPage, { CourierListHeadAction } from "./courier-list-page";
import CourierTable from "./ui/courier-table";

const LiveMonitor = props => {
  const {
    getCourierLiveMonitor,
    liveMonitor = {},
    courierLoading,
    resetCourierState
  } = props;

  const summary = liveMonitor.summary || [];
  const trips = liveMonitor.trips || [];
  const exceptions = liveMonitor.recentExceptions || [];

  useEffect(() => {
    getCourierLiveMonitor();
    return () => resetCourierState();
  }, []);

  return (
    <CourierListPage
      title="Live Monitor"
      count={trips.length}
      countLabel="active"
      loading={courierLoading}
      headActions={
        <CourierListHeadAction
          label="Refresh"
          onClick={() => getCourierLiveMonitor()}
        />
      }
    >
      <ul className="courier-summary">
        {summary.map(s => (
          <li key={s.status} className="courier-summary-card">
            <span className="count">{s.count}</span>
            <span className="label">{s.statusDisplay}</span>
          </li>
        ))}
        {!summary.length && !courierLoading && (
          <li className="empty">No active trips.</li>
        )}
      </ul>

      <h3 className="courier-subhead">Active Trips</h3>
      <CourierTable>
        <thead>
          <tr>
            <th>Code</th>
            <th>Date</th>
            <th>Round</th>
            <th>Courier</th>
            <th>Status</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {trips.map(t => (
            <tr key={t.id}>
              <td>{t.code}</td>
              <td>{t.tripDate}</td>
              <td>{t.round}</td>
              <td>{t.courier}</td>
              <td>{t.statusDisplay}</td>
              <td>
                {t.doneTasks}/{t.totalTasks}
              </td>
            </tr>
          ))}
          {!trips.length && !courierLoading && (
            <tr>
              <td colSpan={6}>No active trips.</td>
            </tr>
          )}
        </tbody>
      </CourierTable>

      <h3 className="courier-subhead">Recent GPS Exceptions</h3>
      <CourierTable>
        <thead>
          <tr>
            <th>Trip</th>
            <th>Task</th>
            <th>Reason</th>
            <th>When</th>
          </tr>
        </thead>
        <tbody>
          {exceptions.map(ex => (
            <tr key={ex.id}>
              <td>{ex.tripCode}</td>
              <td>{ex.taskLabel}</td>
              <td>{ex.reason}</td>
              <td>{ex.createdAt}</td>
            </tr>
          ))}
          {!exceptions.length && !courierLoading && (
            <tr>
              <td colSpan={4}>No recent exceptions.</td>
            </tr>
          )}
        </tbody>
      </CourierTable>
    </CourierListPage>
  );
};

export default LiveMonitor;
